var timePickerData = {
  name: "timePicker",
  data: [{
    dropDownInputHeight: 28,
    columnWidth: 90,
    itemFontSize: 12,
    itemFontColor: "#333333",
    itemHeight: 24,
    selectedBg: "#eff6ff",
    selectedFontColor: "#333"
  }]
};
export default timePickerData;